import React, { useState, useEffect } from 'react';
import './Insights.css';
import { useAdobeDataLayer, PageNames } from '../../hooks/useAdobeDataLayer';
import insightsData from '../../components/Redesign/insights.json';

import downloadImage from 'url:../../assets-optimized/redesign/insights/download_image.png';
import downloadImageavif from 'url:../../assets-optimized/redesign/insights/download_image.avif';
import downloadImagewebp from 'url:../../assets-optimized/redesign/insights/download_image.webp';
import popupImage from 'url:../../assets-optimized/redesign/insights/popup-image.png';
import popupImageavif from 'url:../../assets-optimized/redesign/insights/popup-image.avif';
import popupImagewebp from 'url:../../assets-optimized/redesign/insights/popup-image.webp';
import firstArticle from 'url:../../assets-optimized/redesign/insights/first_article.png';
import firstArticleavif from 'url:../../assets-optimized/redesign/insights/first_article.avif';
import firstArticlewebp from 'url:../../assets-optimized/redesign/insights/first_article.webp';
import secondArticle from 'url:../../assets-optimized/redesign/insights/second_article.png';
import secondArticleavif from 'url:../../assets-optimized/redesign/insights/second_article.avif';
import secondArticlewebp from 'url:../../assets-optimized/redesign/insights/second_article.webp';
import thirdArticle from 'url:../../assets-optimized/redesign/insights/third_article.jpg';
import thirdArticleavif from 'url:../../assets-optimized/redesign/insights/third_article.avif';
import thirdArticlewebp from 'url:../../assets-optimized/redesign/insights/third_article.webp';

import playlist1 from 'url:../../assets-optimized/redesign/insights/playlist/1.png';
import playlist1avif from 'url:../../assets-optimized/redesign/insights/playlist/1.avif';
import playlist1webp from 'url:../../assets-optimized/redesign/insights/playlist/1.webp';
import playlist2 from 'url:../../assets-optimized/redesign/insights/playlist/2.png';
import playlist2avif from 'url:../../assets-optimized/redesign/insights/playlist/2.avif';
import playlist2webp from 'url:../../assets-optimized/redesign/insights/playlist/2.webp';
import playlist3 from 'url:../../assets-optimized/redesign/insights/playlist/3.png';
import playlist3avif from 'url:../../assets-optimized/redesign/insights/playlist/3.avif';
import playlist3webp from 'url:../../assets-optimized/redesign/insights/playlist/3.webp';
import playlist4 from 'url:../../assets-optimized/redesign/insights/playlist/4.png';
import playlist4avif from 'url:../../assets-optimized/redesign/insights/playlist/4.avif';
import playlist4webp from 'url:../../assets-optimized/redesign/insights/playlist/4.webp';
import playlist5 from 'url:../../assets-optimized/redesign/insights/playlist/5.png';
import playlist5avif from 'url:../../assets-optimized/redesign/insights/playlist/5.avif';
import playlist5webp from 'url:../../assets-optimized/redesign/insights/playlist/5.webp';
import playlist6 from 'url:../../assets-optimized/redesign/insights/playlist/6.png';
import playlist6avif from 'url:../../assets-optimized/redesign/insights/playlist/6.avif';
import playlist6webp from 'url:../../assets-optimized/redesign/insights/playlist/6.webp';

import tickerData from '../../components/Redesign/tickerData.json';
import videosData from '../../components/Redesign/videosData.json';
import FaqAccordion from '../../components/Redesign/FaqAccordion';
import ActionButton from '../../components/elements/ActionButton/ActionButton';
import InsightsPopup from '../../components/Redesign/InsightsPopup';
import OptimizedImage from '../../components/Redesign/OptimizedImage';

const imageMap = {
  "/assets-optimized/redesign/insights/download_image.png": { avif: downloadImageavif, webp: downloadImagewebp, fallback: downloadImage },
  "/assets-optimized/redesign/insights/popup-image.png": { avif: popupImageavif, webp: popupImagewebp, fallback: popupImage },
  "/assets-optimized/redesign/insights/first_article.png": { avif: firstArticleavif, webp: firstArticlewebp, fallback: firstArticle },
  "/assets-optimized/redesign/insights/second_article.png": { avif: secondArticleavif, webp: secondArticlewebp, fallback: secondArticle },
  "/assets-optimized/redesign/insights/third_article.jpg": { avif: thirdArticleavif, webp: thirdArticlewebp, fallback: thirdArticle },
  "/assets-optimized/redesign/insights/playlist/1.png": { avif: playlist1avif, webp: playlist1webp, fallback: playlist1 },
  "/assets-optimized/redesign/insights/playlist/2.png": { avif: playlist2avif, webp: playlist2webp, fallback: playlist2 },
  "/assets-optimized/redesign/insights/playlist/3.png": { avif: playlist3avif, webp: playlist3webp, fallback: playlist3 },
  "/assets-optimized/redesign/insights/playlist/4.png": { avif: playlist4avif, webp: playlist4webp, fallback: playlist4 },
  "/assets-optimized/redesign/insights/playlist/5.png": { avif: playlist5avif, webp: playlist5webp, fallback: playlist5 },
  "/assets-optimized/redesign/insights/playlist/6.png": { avif: playlist6avif, webp: playlist6webp, fallback: playlist6 },
  "download_image.png": { avif: downloadImageavif, webp: downloadImagewebp, fallback: downloadImage },
  "popup-image.png": { avif: popupImageavif, webp: popupImagewebp, fallback: popupImage }
};

// Renders an OptimizedImage when the source resolves to a known imported
// variant set; otherwise falls back to a plain <img> for raw/external URLs.
const InsightsImage = ({ source, alt }) => {
  const entry = imageMap[source];
  if (entry) {
    return <OptimizedImage {...entry} alt={alt} />;
  }
  return <img src={source} alt={alt} />;
};

const GlobeIcon = () => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.625 21C2.625 25.8734 4.56093 30.5471 8.00691 33.9931C11.4529 37.4391 16.1266 39.375 21 39.375C25.8734 39.375 30.5471 37.4391 33.9931 33.9931C37.4391 30.5471 39.375 25.8734 39.375 21C39.375 16.1266 37.4391 11.4529 33.9931 8.00691C30.5471 4.56093 25.8734 2.625 21 2.625C16.1266 2.625 11.4529 4.56093 8.00691 8.00691C4.56093 11.4529 2.625 16.1266 2.625 21Z" stroke="#171717" strokeWidth="2" strokeLinejoin="round" />
    <path d="M13.125 21C13.125 16.1266 13.9547 11.4529 15.4315 8.00691C16.9084 4.56093 18.9114 2.625 21 2.625C23.0886 2.625 25.0916 4.56093 26.5685 8.00691C28.0453 11.4529 28.875 16.1266 28.875 21C28.875 25.8734 28.0453 30.5471 26.5685 33.9931C25.0916 37.4391 23.0886 39.375 21 39.375C18.9114 39.375 16.9084 37.4391 15.4315 33.9931C13.9547 30.5471 13.125 25.8734 13.125 21Z" stroke="#171717" strokeWidth="2" strokeLinejoin="round" />
    <path d="M3.9375 27.1328H38.0625M3.9375 14.8828H38.0625" stroke="#171717" strokeWidth="2" strokeLinecap="round" />
  </svg>

);

const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
);

const ArrowUpRightIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="white" />
    <path d="M15.8404 25.4458L26.1523 15.1338" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M26.4465 25.6441L26.4465 14.8342L14.9832 14.8342" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

const ArrowDownIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <polyline points="19 12 12 19 5 12"></polyline>
  </svg>
);

const PlayIcon = () => (
  <svg width="26" height="29" viewBox="0 0 26 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 10.9342C26.6667 12.4738 26.6667 16.3228 24 17.8624L6 28.2547C3.33334 29.7943 0 27.8698 0 24.7906L0 4.00597C0 0.926767 3.33333 -0.997738 6 0.541862L24 10.9342Z" fill="var(--bonvoy-coral)" />
  </svg>

);

const Insights = () => {
  const { sendPageView } = useAdobeDataLayer();
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTicker, setActiveTicker] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [showAllVideos, setShowAllVideos] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    sendPageView(PageNames.Insights);
  }, [sendPageView]);

  useEffect(() => {
    if (tickerData.length <= 1) return;

    const timer = setInterval(() => {
      setActiveTicker((prev) => (prev + 1) % tickerData.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const categories = ['All', 'News', 'Whitepaper', 'Videos', 'Press Releases', 'Insights'];

  const filteredInsights = insightsData.filter(item => {
    const matchesCategory = activeCategory === 'All' || item.category === activeCategory;
    const matchesSearch = item.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.excerpt?.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className='insights-page'>
      {/* Hero Section */}
      <section className='insights-hero'>
        <div className='hero-bg-text-container'>
          <div className='hero-bg-text'>INSIGHTS</div>
          <div className='hero-bg-text'>INSIGHTS</div>
        </div>
        <div className='hero-content-box'>
          <div className='hero-header'>
            <h1>Strategic Insights</h1>
            <GlobeIcon />
          </div>
          <p>Travel is personal. Our insights reveal what inspires guests and guides their thinking.</p>
          <div className='hero-scroll-btn-wrapper'>
            <button className='hero-scroll-btn' onClick={() => {
              const el = document.getElementById('deep-dives');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}>
              <svg viewBox='0 0 24 24' fill='none' stroke='#1c1c1c' strokeWidth='0.5'>
                <line x1='12' y1='5' x2='12' y2='19' />
                <polyline points='19 12 12 19 5 12' />
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* Ticker Section */}
      <section className='insights-ticker'>
        <div className='ticker-carousel-container'>
          {tickerData.map((item, idx) => (
            <div
              key={item.id}
              className={`ticker-bar ${idx === activeTicker ? 'active' : 'inactive'}`}
            >
              <div className='ticker-img-wrapper'>
                <InsightsImage source={item.image} alt={item.text} />
              </div>
              <div className='ticker-text'>
                {item.text}
              </div>
              <button
                className='ticker-btn'
                onClick={(e) => {
                  if (item.buttonText.toLowerCase().includes('download')) {
                    e.preventDefault();
                    setIsPopupOpen(true);
                  }
                }}
              >
                {item.buttonText} <span className="ticker__icon-circle"><ArrowUpRightIcon /></span>
              </button>
            </div>
          ))}
        </div>
        {tickerData.length > 1 && (
          <div className='ticker-dots'>
            {tickerData.map((_, idx) => (
              <span
                key={idx}
                className={`dot ${idx === activeTicker ? 'active' : ''}`}
                onClick={() => setActiveTicker(idx)}
              ></span>
            ))}
          </div>
        )}
      </section>

      {/* Featured Deep Dives */}
      <section id='deep-dives' className='featured-deep-dives'>
        <div className='fdd-header'>
          <h2>FEATURED <span>DEEP DIVES</span></h2>
        </div>

        {filteredInsights.length > 0 && (() => {
          const firstArticle = filteredInsights[0];
          const CardWrapper = firstArticle.link ? 'a' : 'div';
          const wrapperProps = firstArticle.link ? { href: firstArticle.link, target: '_blank', rel: 'noopener noreferrer' } : {};

          return (
            <CardWrapper className='article-card large-full blue-bg' {...wrapperProps} style={{ textDecoration: 'none' }}>
              <div className='card-image-wrapper'>
                {firstArticle.image && <InsightsImage source={firstArticle.image} alt={firstArticle.title} />}
              </div>
              <div className='card-content'>
                {firstArticle.category && <span className='category-tag'>{firstArticle.category}</span>}
                <h3>
                  {firstArticle.title}
                  {firstArticle.link && <span className='sr-only'> (opens in a new tab)</span>}
                </h3>
                <p>{firstArticle.excerpt}</p>
                <div className='card-footer'>
                  {firstArticle.date && <span className='date'>{new Date(firstArticle.date).toLocaleDateString('en-GB').replace(/\//g, '.')}</span>}
                  {firstArticle.buttonText && (
                    <button
                      className='card-btn'
                      onClick={(e) => {
                        if (firstArticle.buttonText.toLowerCase().includes('download')) {
                          e.preventDefault();
                          setIsPopupOpen(true);
                        }
                      }}
                    >
                      {firstArticle.buttonText}
                    </button>
                  )}
                </div>
              </div>
            </CardWrapper>
          );
        })()}

        <div className='articles-grid'>
          {filteredInsights.slice(1).map((article, idx) => {
            const actualIdx = idx + 1;
            let cardClass = 'article-card small';
            if (actualIdx === 4 || actualIdx === 5) cardClass = 'article-card large-half ' + (actualIdx === 4 ? 'orange-bg' : 'dark-bg');

            const CardWrapper = article.link ? 'a' : 'div';
            const wrapperProps = article.link ? { href: article.link, target: '_blank', rel: 'noopener noreferrer' } : {};

            return (
              <CardWrapper key={article.id || actualIdx} className={cardClass} {...wrapperProps} style={{ textDecoration: 'none' }}>
                <div className='card-image-wrapper'>
                  {article.image && <InsightsImage source={article.image} alt={article.title} />}
                </div>
                <div className='card-content'>
                  {article.category && <span className='category-tag'>{article.category}</span>}
                  <h3>
                    {article.title}
                    {article.link && <span className='sr-only'> (opens in a new tab)</span>}
                  </h3>
                  <p>{article.excerpt}</p>
                  <div className='card-footer'>
                    {article.date && <span className='date'>{new Date(article.date).toLocaleDateString('en-GB').replace(/\//g, '.')}</span>}
                    {article.buttonText && (
                      <button
                        className='card-btn'
                        onClick={(e) => {
                          if (article.buttonText.toLowerCase().includes('download')) {
                            e.preventDefault();
                            setIsPopupOpen(true);
                          }
                        }}
                      >
                        {article.buttonText}
                      </button>
                    )}
                  </div>
                </div>
              </CardWrapper>
            )
          })}
        </div>
      </section>

      {/* FAQ AND MEDIA RESOURCES */}
      <FaqAccordion />

      {/* MARRIOTT BONVOY VIDEOS */}
      <section className='bonvoy-videos'>
        <h2>WHERE TRAVEL STORIES EARN ATTENTION</h2>
        <p>Explore travel content featuring inspirational itineraries, great destinations and unique guest experiences across our portfolio of extraordinary hotel brands.</p>

        <div className='videos-grid'>
          {(isMobile && !showAllVideos ? videosData.slice(0, 3) : videosData).map((video, idx) => (
            <a key={idx} className={`video-card-container ${isMobile && showAllVideos && idx >= 3 ? 'animate-video-in' : ''}`} style={{ textDecoration: 'none', animationDelay: `${(idx - 3) * 0.1}s` }} href={video.link} target="_blank" rel="noopener noreferrer">
              <div className='video-card'>
                <InsightsImage source={video.image} alt={video.title} />
                <div className='video-overlay'>
                  <div className='video-play-btn'>
                    <PlayIcon />
                  </div>
                </div>
                <div className='video-duration-pill'>
                  {video.duration}
                </div>
              </div>
              <h3 className='video-title'>
                {video.title}
                <span className='sr-only'> (opens in a new tab)</span>
              </h3>
            </a>
          ))}
        </div>

        {isMobile && !showAllVideos && videosData.length > 3 && (
          <div className='view-more-container'>
            <ActionButton text="View more" onClick={() => setShowAllVideos(true)} />
          </div>
        )}
      </section>

      <InsightsPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default Insights;
